import Accordion from 'components/Accordion';
import DetailsViewCardApplicationList from 'components/DetailsViewCardApplicationList';
import DetailsViewCardApplicationsListContainer from 'components/containers/DetailsViewCardApplicationsListContainer';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const ApplicationsAccordion: FunctionComponent<Props> = ({
    applications,
    isLoading,
    isOpen,
    label,
    onSelectApplication,
    onToggle,
    selectedApplicationId,
    testId = TEST_ID
}) => (
    <Accordion isOpen={isOpen} label={label} onToggle={onToggle} testId={testId}>
        <DetailsViewCardApplicationsListContainer>
            <DetailsViewCardApplicationList
                applications={applications}
                isLoading={isLoading}
                onSelectApplication={onSelectApplication}
                selectedApplicationId={selectedApplicationId}
            />
        </DetailsViewCardApplicationsListContainer>
    </Accordion>
);

export default ApplicationsAccordion;
